import * as routes from "../Router/RoutesURL";
import { createNotification } from '../Config/NotificationToast';
import { REACT_APP_ENCRYPTION_KEY } from "../Config/Constant";

export const rowOptions = [
    { value: 5, label: '5' },
    { value: 10, label: '10' },
    { value: 15, label: '15' },
];

export const options = [
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'Inactive' },
];

export const testimonialsoptions = [
    { value: 'Pending', label: 'Pending' },
    { value: 'Approved', label: 'Approved' },
    { value: 'Rejected', label: ' Rejected' },
];


export const Leveloptions = [
    { value: 'Comprehensive', label: 'Comprehensive' },
    { value: 'Foundation & Comprehensive', label: 'Foundation & Comprehensive' },
];

export const durationOptions = [
    { value: '15', label: '15 Minutes' },
    { value: '30', label: '30 Minutes' },
    { value: '45', label: '45 Minutes' },
    { value: '60', label: '60 Minutes' },
    { value: '75', label: '75 Minutes' },
    { value: '90', label: '90 Minutes' },
    { value: '120', label: '120 Minutes' },
    { value: '150', label: '150 Minutes' },
    { value: '180', label: '180 Minutes' },
    { value: '210', label: '210 Minutes' },
    { value: '240', label: '240 Minutes' },
    { value: '270', label: '270 Minutes' },
    { value: '300', label: '300 Minutes' },
];

export const frequencyOptions = [
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
    { value: 'monthly', label: 'Monthly' }
];

export const weekdays = [
    { value: 0, day: 'Sun' },
    { value: 0, day: 'Mon' },
    { value: 0, day: 'Tue' },
    { value: 0, day: 'Wed' },
    { value: 0, day: 'Thu' },
    { value: 0, day: 'Fri' },
    { value: 0, day: 'Sat' },
];


export const addSuffix = (num) => {
    if (num % 100 >= 11 && num % 100 <= 13) {
        return num + "th";
    } else if (num % 10 === 1) {
        return num + "st";
    } else if (num % 10 === 2) {
        return num + "nd";
    } else if (num % 10 === 3) {
        return num + "rd";
    } else {
        return num + "th";
    }
}

const CryptoJS = require("crypto-js");
export const encryptUrlData = (data) => {
    return CryptoJS.AES.encrypt(data, REACT_APP_ENCRYPTION_KEY).toString()
}
export const encryptData = (data) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), REACT_APP_ENCRYPTION_KEY).toString()
}

export const decryptData = (data) => {
    var bytes = CryptoJS.AES.decrypt(data, REACT_APP_ENCRYPTION_KEY);
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData
}

export const logOut = (type, msg) => {
    localStorage.clear();
    window.location.href = routes.LOG_IN;
    createNotification(type, msg);
}

export const descendingComparator = (a, b, orderBy) => {
    const valA = a?.[orderBy];
    const valB = b?.[orderBy];
  
    // Handle null / undefined first
    if (valA == null && valB == null) return 0;
    if (valA == null) return 1; // null/undefined -> goes to bottom
    if (valB == null) return -1;
  
    // Robust parser for "YYYY-MM-DD HH:mm:ss"
    const parseDate = (val) => {
      if (typeof val === "string" && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(val)) {
        const [datePart, timePart] = val.split(" ");
        const [year, month, day] = datePart.split("-").map(Number);
        const [hour, minute, second] = timePart.split(":").map(Number);
        return new Date(year, month - 1, day, hour, minute, second); // month is 0-based
      }
      if (val instanceof Date) return val;
      return null;
    };
  
    const dateA = parseDate(valA);
    const dateB = parseDate(valB);
  
    // Compare dates if both valid
    if (dateA && dateB) {
      if (dateB < dateA) return -1;
      if (dateB > dateA) return 1;
      return 0;
    }
  
    // Handle strings (non-dates)
    if (typeof valA === "string" && typeof valB === "string") {
      if (valB.toLowerCase() < valA.toLowerCase()) return -1;
      if (valB.toLowerCase() > valA.toLowerCase()) return 1;
    }
  
    // Handle numbers
    if (typeof valA === "number" && typeof valB === "number") {
      if (valB < valA) return -1;
      if (valB > valA) return 1;
    }
  
    return 0;
  };
  
export const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

export const getComparator = (order, orderBy) => {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

export const getPermissionByAppName = (appName) => {
    const userData = JSON.parse(localStorage.getItem('UserData'));
    const filteredObject = userData?.permissions?.find(x => x.app_name === appName);
    return filteredObject?.permission;
}
export const getRandomName=()=> { // Public Domain/MIT
  var d = new Date().getTime();//Timestamp
  var d2 = (performance && performance.now && (performance.now() * 1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16;//random number between 0 and 16
      if (d > 0) {//Use timestamp until depleted
          r = (d + r) % 16 | 0;
          d = Math.floor(d / 16);
      } else {//Use microseconds since page-load if supported
          r = (d2 + r) % 16 | 0;
          d2 = Math.floor(d2 / 16);
      }
      return (c === 'x' ? r : (r & (0x3 | 0x8))).toString(16);
  });
}


export function validateDate(date) {
    if(date === null || date === undefined || date === '')
        return false;

    // Accept both ISO 'T' separator and space-separated datetime (e.g. '2024-01-15 10:30:00')
    const isoFlexibleRegex = /^\d{4}-\d{2}-\d{2}([T ]\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[\+\-]\d{2}:\d{2})?)?$/;

    if (isoFlexibleRegex.test(date)) {
      // Normalise space-separated datetime to ISO format so all browsers (incl. Safari) parse correctly
      const normalised = typeof date === 'string' ? date.replace(' ', 'T') : date;
      let d = new Date(normalised);
      return (d instanceof Date && !isNaN(d.valueOf()))
    }

    return false
    
}


export function downloadFileFromURL (url, fileName){
    try{
        var a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
      }catch(e){
        console.log(e)
      }
  }

  export const parseJSON=(data)=>{
    let parsed = undefined;
    try{
      parsed = JSON.parse(data);
    }catch(e){
    //   console.log(data)
    }
    return parsed;
  }
  

  export const ADD = 'Add'
  export const EDIT = 'Edit'


  export function downloadExcel ({data, fileName}){
    try{
        var url = window.URL.createObjectURL(new Blob([data]));
        var a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a); // append the element to the dom
        a.click();
        a.remove();
      }catch(e){
        console.log(e)
      }
  }
  